export default __webpack_public_path__ + "static/assets/f9158db67717e38d328368ea52e43419.svg";